import React, { Fragment, useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { ApiRequestBuilder, ButtonBuilder } from "../../../../../../GlobalComponents/Builders";
import { sortArrayByKey, isAdminUser } from '../../../../../../GlobalComponents/Helpers';
import DMTProgressDashboard from "../DMT/components/progress/DMTProgress";
import { ContentLoader } from '../../../../../../Layout/Loader';
import { AccountContext } from '../../../../../../GlobalComponents/Authentication/Accounts';

const Subpage = () => {

    let { toolId, jobId, subpage, subpageId } = useParams();

    const [jobData, setJobData] = useState([]);
    const [loadingPage, setLoadingPage] = useState(false)
    const [toolData, setToolData] = useState({});
    const [renderPage, setRenderPage] = useState(false);
    const [error, setError] = useState(null);
    const [connectionData, setConnectionData] = useState([]);
    const { isAdmin } = useContext(AccountContext);

    const navigate = useNavigate();

    useEffect(() => {

        if (loadingPage) return

        setLoadingPage(true)

        ApiRequestBuilder('toolsToolIdGet', { toolId }).then(function(results){
            setToolData(results.data ? results.data : {})
        })

        ApiRequestBuilder('connectionsGet')
            .then(function(results) {
                results.data && results.data.length > 0 ? setConnectionData(sortArrayByKey(results.data, 'name')) : null
            }
        )

        ApiRequestBuilder('toolsToolIdJobsJobIdGet', { toolId, jobId }).then(function(results){
            if (results.data) {
                setJobData(results.data)
                setRenderPage(true)
            }
            else {
                if (isAdmin) {
                    setError(`Error: This ${toolId} job does not exist.`);
                } else {
                    window.location.href = `${process.env.PUBLIC_URL}/tools/${toolId}`;
                }
            }
        })

    }, [loadingPage]);

    const renderToolPage = () => {
        switch(subpage)
        {
            case 'progress':
                return <DMTProgressDashboard toolData={toolData} jobData={jobData} connectionData={connectionData} />
            case 'orders': 
                window.location.href = `${process.env.PUBLIC_URL}/oep/orders/${subpageId}`
                return null
            default:
                return <p>I don't think you are supposed to be here</p>
        }
    }

    return renderPage ?
    <> {renderToolPage()} </> :
    <>
        {error ? <span>{error}</span> : <ContentLoader/>}
        <br/>
        <br/>
        {error ? <ButtonBuilder label= 'Back to Jobs' onClick={() => navigate(`${process.env.PUBLIC_URL}/tools/data-migration`)}/> : null}
    </>
};

export default Subpage;
